import { RootState } from 'types'
import { Action } from 'redux/actions'
import { HandbookActions } from 'redux/actions/handbooks'
import produce from 'immer'

export default function reduce(state: RootState['handbook'] = null, action: Action): RootState['handbook'] {
  switch (action.type) {
    case HandbookActions.SET_HANDBOOK: {
      return action.payload
    }
    case HandbookActions.UPDATE_HANDBOOK: {
      return produce(state, (draft) => {
        if (!draft) return
        Object.assign(draft, action.payload)
      })
    }
    default:
      return state
  }
}
